import { getMarkets } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const MARKET_LIST = "MARKET_LIST";

export function useMarketListQuery() {
	return useQuery({
		queryKey: [MARKET_LIST],
		queryFn: processResponse(() => getMarkets()),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
